export const EnvironmentalMetrics = [
  {value: '1', label: 'Scope 1 GHG Emissions'},
  {value: '2', label: 'Scope 2 GHG Emissions'},
  {value: '3', label: 'Scope 3 GHG Emissions'},
  {value: '4', label: 'Energy Consumption (Renewable/Non-renewable)'},
  {value: '5', label: 'Water Consumption'},
  {value: '6', label: 'Water Recycling Rate'},
  {value: '7', label: 'Waste Management (Hazardous/Non-Hazardous)'},
  {value: '8', label: 'Biodiversity Impact Management'}
];

export const SocialMetrics = [
  {value: '1', label: 'Workforce Diversity'},
  {value: '2', label: 'Board Diversity'},
  {value: '3', label: 'Skill Upgradation %'},
  {value: '4', label: 'Employee Turnover Rate'},
  {value: '5', label: 'Occupational Health & Safety (Injury Rates)'},
  {value: '6', label: 'Human Rights Policy Implementation %'},
  {value: '7', label: 'Supply Chain Social Assessments'}
];

export const GovernanceMetrics = [
  {value: '1', label: 'ESG Oversight by Board'},
  {value: '2', label: 'Anti-Bribery/Anti-Corruption Policies'}
];
